import { computed } from 'vue';
import { convertToGroups } from '@/containers/utils/utils.js';
import store from '@/store';

export function useProductTypeGroups() {
  const productTypeGroupsList = computed(() => store.getters['productType/getProductTypeGroups']);
  const getProductTypeGroups = async (
    productTypeCodes,
    comparedValue = 'parentProductTypeName',
    excludeResources = []
  ) => {
    if (!productTypeGroupsList.value.length)
      await store.dispatch('productType/setProductTypeGroups');
    return convertToGroups(
      productTypeCodes,
      comparedValue,
      productTypeGroupsList.value,
      excludeResources
    );
  };
  const getOriginalProductTypeGroups = async () => {
    if (!productTypeGroupsList.value.length)
      await store.dispatch('productType/setProductTypeGroups');
    return productTypeGroupsList.value;
  };

  return {
    getProductTypeGroups,
    getOriginalProductTypeGroups
  };
}
